import React from 'react';

function Copyright() {

	return (
		<div className="grid-x copyright bt1-ccc bb1-ccc ptb-20 mlr-10 bg-eee">
			<div className="large-12 medium-12 small-12 cell text-center">
				<div className="font-libre-baskerville font-size-16 font-weight-800 txt-feliz-blue pt-5">Love Leads</div>
				<div className="font-libre-baskerville font-size-16 font-weight-500 txt-feliz-blue pt-10l-5s">&nbsp;&nbsp;&nbsp;<i>the</i> Way</div>
				<div className="font-poppins font-size-14 font-weight-400 txt-333 uppercase pt-5">&copy;&nbsp;2026</div>
				<div className="font-poppins font-size-14 font-weight-400 txt-333  pt-20">Update: 08/17/2026</div>
			</div>
		</div>
	);

}

export default Copyright;